import React, { Component } from 'react'

export default class AboutPage extends Component {
    render() {
        return (
            <main>
                <h2>Shelby Strouse</h2>
                <a href='https://www.linkedin.com/in/shelby-strouse-full-stack-eng/'>
                    <h4>LinkedIn</h4>
                </a>
                <div className="about-div">
                    <img src="https://media-exp1.licdn.com/dms/image/C5603AQFT4NFic9wNVg/profile-displayphoto-shrink_100_100/0/1611003856787?e=1620864000&v=beta&t=grbYQHikT2mfTXkOkBkyiyiMUUKAc6yoRSVBOR7z4Bc" alt="kitten" className="about-image"/>
                    <div className="about-text">
                    Shelby Strouse is a full-stack Software Engineer who loves sun-seeking adventurers!
                    </div>
                </div>
                <h2>Cherno Badjan</h2>
                <a href='https://www.linkedin.com/in/chernobadjan/'>
                    <h4>LinkedIn</h4>
                </a>
                <div className="about-div">
                    <img src="https://media-exp1.licdn.com/dms/image/C5603AQEAKZIZBv2FtA/profile-displayphoto-shrink_800_800/0/1612209733545?e=1620864000&v=beta&t=eXuMAaOBnyO3wdGzA71G5-qFmo4mHtRvbb-ETrFv6_Q" alt="kitten" className="about-image"/>
                    <div className="about-text">
                        Full-Stack Software Engineer with a real sunny personality!
                    </div>
                </div>
                <h2>Stephen Leisy</h2>
                <a href='https://www.linkedin.com/in/chernobadjan/'>
                    <h4>LinkedIn</h4>
                </a>
                <div className="about-div">
                    <img src="https://media-exp1.licdn.com/dms/image/C4E03AQEFZLsx54T07A/profile-displayphoto-shrink_800_800/0/1609975176414?e=1620864000&v=beta&t=C_iAij7Mi2OuTR8rCLehMdcLTBTlYNHa1-BrGzj4IUo" alt="kitten" className="about-image"/>
                    <div className="about-text">
                        Stephen Leisy is a human who needs sunshine but also a full-stack Software Engineerer who hides in a basement.
                    </div>
                </div>
                <h2>Erich Sauer</h2>
                <a href='https://www.linkedin.com/in/erichsauer/'>
                    <h4>LinkedIn</h4>
                </a>
                <div className="about-div">
                    <img src="https://media-exp1.licdn.com/dms/image/C4E03AQFNqvom3DWxLA/profile-displayphoto-shrink_800_800/0/1604601866824?e=1620864000&v=beta&t=tyYBJL6mRoFkpXYXod5vDU-CwNR04GI8Q1XbbOJ_by0" alt="kitten" className="about-image"/>
                    <div className="about-text">
                       Erich Sauer is a full-stack Software Developer who loves photosynthesizing whenever possible!
                    </div>
                </div>
            </main>
        )
    }
}
